import React, { FC } from "react";

import { Drawer } from "@components/common";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { QuestionsTable } from "@components/main/questions";
import { useAddQuestionsToSection } from "@api";
import { useUserStore } from "@store/user";

const AddQuestionDrawer: FC = () => {
  const {
    addQuestionOpen,
    setAddQuestionOpen,
    activeSection,
    formSettings: {
      formBasics: { id },
    },
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { addQuestionsToSectionAsync, addQuestionsToSectionEnabled } =
    useAddQuestionsToSection(user, id, activeSection?.id ?? "");

  const handleAddQuestions = async (questionIds: string[]): Promise<void> => {
    try {
      if (activeSection) {
        await addQuestionsToSectionAsync({
          sectionId: activeSection.id,
          questionIds: questionIds.map((id) => ({
            questionId: id,
            isRequired: false,
          })),
        });
      }
      setAddQuestionOpen(false);
    } catch {
      // Error is handled by the onError callback in useAddQuestionsToSection
    }
  };

  return (
    addQuestionsToSectionEnabled &&
    activeSection && (
      <Drawer
        open={addQuestionOpen}
        onClose={() => setAddQuestionOpen(false)}
        content={<QuestionsTable onSelect={handleAddQuestions} />}
        noPadding
      />
    )
  );
};

export default AddQuestionDrawer;
